import React from "react";
import CourseHeader from "../Shared/CourseHeader";
import cyberImg from "../../../assets/cybersecurity solutions.jpeg";

const CyberSecurityHeader = ({ componentData }) => {
  // Use componentData from CMS if available, otherwise use defaults
  const title = componentData?.title || "Cyber";
  const subtitle = componentData?.subtitle || "Security";
  const content = componentData?.content || "Defend. Protect. Secure the Future.";
  const backgroundImage = componentData?.mediaUrl || cyberImg;

  return (
    <CourseHeader
      title={title}
      highlight={subtitle}
      subtitle={content}
      backgroundImage={backgroundImage}
      cta={{ label: "Start Application", targetId: "application-form" }}
    />
  );
};

export default CyberSecurityHeader;
